export const setInitialHistoryX = ({
  historyX,
  draggableBlockLeftX,
  sourceOffset,
  leftXOffset,
  targetLayerIndex,
  overNewLayerIndex,
}) => {
  if (!historyX.current.draggableBlockLeftX) {
    // eslint-disable-next-line no-param-reassign
    historyX.current = {
      ...historyX.current,
      draggableBlockLeftX,
      stopDragLeftX: draggableBlockLeftX,
      dropX: sourceOffset.x - leftXOffset,
    }
  }

  if (historyX.current.currentLayerIndex !== targetLayerIndex && !overNewLayerIndex) {
    // eslint-disable-next-line no-param-reassign
    historyX.current = {
      ...historyX.current,
      isMountedOnLayer: true,
      currentLayerIndex: targetLayerIndex,
    }
  }

  if (overNewLayerIndex) {
    // eslint-disable-next-line no-param-reassign
    historyX.current = {
      isMountedOnLayer: false,
      dropX: 0,
      draggableBlockLeftX: 0,
      stopDragLeftX: 0,
      readyForDrop: false,
      isIntersected: false,
      intersectedData: null,
      moveDirection: null,
      currentLayerIndex: null,
      isIncorrectPosition: false,
    }
  }
}
